import { render, staticRenderFns } from "./Procurement_approval.vue?vue&type=template&id=3006978e&scoped=true"
import script from "./Procurement_approval.vue?vue&type=script&lang=js"
export * from "./Procurement_approval.vue?vue&type=script&lang=js"
import style0 from "./Procurement_approval.vue?vue&type=style&index=0&id=3006978e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3006978e",
  null
  
)

export default component.exports